module.exports = __webpack_public_path__ + "static/img/增值服务模块.bf89156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/增值服务模块.png
// module id = mAat
// module chunks = 1